import { ErrorLabel } from '@styles/shared-styles';
import {
    applyBottomPixelSpacing,
    applyGradedInnerSpacing,
    applyOptionalSpacing,
    applyTopPixelSpacing,
    getSpacingGrades,
    SpacingGrade
} from '@styles/spacing-styles';
import * as React from 'react';
import styled from 'styled-components';

interface ButtonsProps {
    topSpacing?: SpacingGrade;
    bottomSpacing?: SpacingGrade;
    innerSpacing?: SpacingGrade;
    justifyContent?: React.CSSProperties['justifyContent'];
}

export const Buttons = styled.div<ButtonsProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent ? justifyContent : 'space-between'};
  ${({ topSpacing = 'medium' }) => applyOptionalSpacing(applyTopPixelSpacing, getSpacingGrades()[topSpacing])};
  ${({ bottomSpacing = 'large' }) => applyOptionalSpacing(applyBottomPixelSpacing, getSpacingGrades()[bottomSpacing])};
  ${({ innerSpacing = 'none' }) => applyGradedInnerSpacing('left', getSpacingGrades(), 'none', innerSpacing)};
`;

export const DashedDivider = styled.div({
    width: '100%',
    borderBottom: '2px dashed rgba(0, 0, 0, 0.3)'
});

export const SolidDivider = styled.div({
  width: '100%',
  borderBottom: '2px solid rgba(0, 0, 0, 0.1)'
});

export const FocusedError = styled(ErrorLabel)`
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/styles.tsx